import React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./list";
import "./index.css";
const Production = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/:clientStatus`} component={List} />
    </Switch>
  );
};

export default Production;
